export default function Download() {
  return (
    <>
      <section className="section section-cta">
        <div className="container cta-inner">
          <div>
            <p className="section-eyebrow">Get the app</p>
            <h2 className="section-title">Book on the go</h2>
            <p className="section-sub">
              Download the RouteRider app for faster booking, live tracking and
              exclusive fares.
            </p>
            <div className="app-badges">
              <a href="#">
                <img
                  src="/assets/website/images/badge-appstore.svg"
                  alt="Download on the App Store"
                />
              </a>
              <a href="#">
                <img
                  src="/assets/website/images/badge-googleplay.svg"
                  alt="Get it on Google Play"
                />
              </a>
            </div>
          </div>
          <div className="cta-fleet-card">
            <h3>Own a cab or a fleet?</h3>
            <p>
              Partner with RouteRider and earn more with per-seat and full-cab
              bookings on your existing routes.
            </p>
            <button
              className="btn btn-white"
              onClick={() =>
                document
                  .getElementById("fleetOwnerPartners")
                  ?.scrollIntoView({ behavior: "smooth", block: "start" })
              }
            >
              Become a Fleet Owner →
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
